import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

/**
 * Detects text direction based on the first strong directional character.
 * Returns 'rtl' for Arabic/Hebrew scripts, 'ltr' for Latin and others.
 * Similar to how ChatGPT and Claude handle mixed-language text.
 */
export const detectTextDirection = (text: string): 'ltr' | 'rtl' => {
  if (!text) return 'ltr';

  // Find first strong directional character
  // RTL: Arabic (0600-06FF, 0750-077F, 08A0-08FF, FB50-FDFF, FE70-FEFF), Hebrew (0590-05FF, FB1D-FB4F)
  // LTR: Latin (0041-007A, 00C0-024F), and most other scripts
  const rtlRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0590-\u05FF\uFB1D-\uFB4F]/;
  const ltrRegex = /[A-Za-z\u00C0-\u024F\u1E00-\u1EFF]/;

  for (const char of text) {
    if (rtlRegex.test(char)) return 'rtl';
    if (ltrRegex.test(char)) return 'ltr';
  }

  return 'ltr';
};
